const DisplayIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.6327 14.9763H5.36602C2.04935 14.9763 1.04102 13.968 1.04102 10.6513V5.36797C1.04102 2.0513 2.04935 1.04297 5.36602 1.04297H14.6243C17.941 1.04297 18.9493 2.0513 18.9493 5.36797V10.643C18.9577 13.968 17.9493 14.9763 14.6327 14.9763ZM5.36602 2.29297C2.74935 2.29297 2.29102 2.7513 2.29102 5.36797V10.643C2.29102 13.2596 2.74935 13.718 5.36602 13.718H14.6243C17.241 13.718 17.6993 13.2596 17.6993 10.643V5.36797C17.6993 2.7513 17.241 2.29297 14.6243 2.29297H5.36602Z"
            />
            <path
                d="M10 18.9599C9.65833 18.9599 9.375 18.6766 9.375 18.3349V14.3516C9.375 14.0099 9.65833 13.7266 10 13.7266C10.3417 13.7266 10.625 14.0099 10.625 14.3516V18.3349C10.625 18.6766 10.3417 18.9599 10 18.9599Z"
            />
            <path
                d="M18.3327 11.457H1.66602C1.32435 11.457 1.04102 11.1737 1.04102 10.832C1.04102 10.4904 1.32435 10.207 1.66602 10.207H18.3327C18.6743 10.207 18.9577 10.4904 18.9577 10.832C18.9577 11.1737 18.6743 11.457 18.3327 11.457Z"
            />
            <path
                d="M13.75 18.957H6.25C5.90833 18.957 5.625 18.6737 5.625 18.332C5.625 17.9904 5.90833 17.707 6.25 17.707H13.75C14.0917 17.707 14.375 17.9904 14.375 18.332C14.375 18.6737 14.0917 18.957 13.75 18.957Z"
            />
        </svg>

    )
}

export default DisplayIcon